<template>
  <a-modal
    :footer="null"
    :maskClosable="false"
    centered
    :destroyOnClose="true"
    :visible="loginModal"
    @cancel="cancelLoginModal"
  >
    <div class="login-modal">
      <p class="title">第三方登录</p>
      <div id="qr">
        <div class="qr-code-img" id="login_container"></div>
        <div class="qr-code-tips">扫描二维码登录</div>
      </div>
      <!-- <p class="tips"></p> -->
    </div>
  </a-modal>
</template>
<script>
import { wechatLogin } from "@/utils/api";
export default {
  data() {
    return {};
  },
  props: {
    loginModal: Boolean,
  },
  mounted() {
    wechatLogin({ url: window.location.href }).then(({ qr_code }) => {
      const { app_id: appid, ...rest } = qr_code;
      this.$parent.setSession();
      var obj = new WxLogin({
        id: "login_container",
        appid,
        ...rest,
      });
    });
  },
  methods: {
    cancelLoginModal() {
      this.$emit("cancelLoginModal");
    },
  },
};
</script>
<style scoped>
.login-modal {
  text-align: center !important;
}
.login-modal .title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  margin-bottom: 44px;
}
.qr-code-tips {
  margin-bottom: 34px;
}
.qr-code-img {
  margin-bottom: 5px;
}
</style>